import { Component } from '@angular/core';

@Component({
  selector: 'app-technical',
  template: `<app-audit-category sectionKey="technical"></app-audit-category>`,
})
export class TechnicalComponent {}
